export const ORDER_STATUSES_LIST_KEY = 'ORDER_STATUSES_LIST';
export const ORDER_STATUSES_ONE_KEY = 'ORDER_STATUSES_ONE_KEY';

export const ORDER_STATUSES_ALL_KEY = 'ORDER_STATUSES_ALL_KEY';
export const ORDER_STATUSES_SUBORDER_ALL_KEY = 'ORDER_STATUSES_SUBORDER_ALL_KEY';

export const ORDER_STATUSES_ALLOWED_LIST_KEY = 'ORDER_STATUSES_ALLOWED_LIST_KEY';
